<script>
import appConfig from "@/app.config";

/**
 * Auth-login component
 */
export default {
  page: {
    title: "Authorization Required",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
};
</script>

<template>
  <div class="text-center min-vh-100 d-flex align-items-center justify-content-center">
    <div class="p-5 border-1 border-success border">
      <span class="text-success h1">認証に失敗しました。</span>
    </div>
  </div>
</template>
